 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER401USINGFORTUNETELLINGASAGUIDE from '@/components/0_chapter401usingfortunetellingasaguide'
 import A_CHAPTER402EVILAVOIDINGNEEDSTOGOSOUTH from '@/components/1_chapter402evilavoidingneedstogosouth'
 import A_CHAPTER403DEPARTUREHURTSTHEMOST from '@/components/2_chapter403departurehurtsthemost'
 import A_CHAPTER404CLOUDMUDTEMPLE from '@/components/3_chapter404cloudmudtemple'
 import A_CHAPTER405REPAIRINGCORPSECONTROLARRAY from '@/components/4_chapter405repairingcorpsecontrolarray'
 import A_CHAPTER406THEAFTERTASTEISTHEFASTNOODLE from '@/components/5_chapter406theaftertasteisthefastnoodle'
 import A_CHAPTER407ROUNDNESSASADEMON from '@/components/6_chapter407roundnessasademon'
 import A_CHAPTER408SLOWEATING from '@/components/7_chapter408sloweating'
 import A_CHAPTER409UNDEADZOMBIE from '@/components/8_chapter409undeadzombie'
 import A_CHAPTER410PALEOPROTOZOA from '@/components/9_chapter410paleoprotozoa'
 import A0_CHAPTER411OBSERVINGTHECHANGES from '@/components/10_chapter411observingthechanges'
 import A1_CHAPTER412BREAKTHROUGHTHEFORMATIONANDENTER from '@/components/11_chapter412breakthroughtheformationandenter'
 import A2_CHAPTER413ICEWATERDEPRESSINGSOUL from '@/components/12_chapter413icewaterdepressingsoul'
 import A3_CHAPTER414DOWNHILL from '@/components/13_chapter414downhill'
 import A4_CHAPTER415DARKSPIRIT from '@/components/14_chapter415darkspirit'
 import A5_CHAPTER416ENGRAMSPACE from '@/components/15_chapter416engramspace'
 import A6_CHAPTER417BLACKLIGHTBALL from '@/components/16_chapter417blacklightball'
 import A7_CHAPTER418WOODBASED from '@/components/17_chapter418woodbased'
 import A8_CHAPTER419SELFDETONATION from '@/components/18_chapter419selfdetonation'
 import A9_CHAPTER420FIVEYINCONNECTINGLAMP from '@/components/19_chapter420fiveyinconnectinglamp'
 import A0_CHAPTER421MEANSOFCOMMUNICATION from '@/components/20_chapter421meansofcommunication'
 import A1_CHAPTER422PHAGOCYTOSISOFEVILQI from '@/components/21_chapter422phagocytosisofevilqi'
 import A2_CHAPTER423SUMMONTHUNDER from '@/components/22_chapter423summonthunder'
 import A3_CHAPTER424THEREISNOESCAPEFROMTHEPALMOFTHEHAND from '@/components/23_chapter424thereisnoescapefromthepalmofthehand'
 import A4_CHAPTER425PUSHCOMPASS from '@/components/24_chapter425pushcompass'
 import A5_CHAPTER426YINYANGMIRROR from '@/components/25_chapter426yinyangmirror'
 import A6_CHAPTER427FLYINGWOOD from '@/components/26_chapter427flyingwood'
 import A7_CHAPTER428DEMONICWOLFCORE from '@/components/27_chapter428demonicwolfcore'
 import A8_CHAPTER429ACOFFINFALLINGFROMTHESKY from '@/components/28_chapter429acoffinfallingfromthesky'
 import A9_CHAPTER430COFFINMAN from '@/components/29_chapter430coffinman'
 import A0_CHAPTER431DARKZONE from '@/components/30_chapter431darkzone'
 import A1_CHAPTER432CONFINEMENTSYMBOL from '@/components/31_chapter432confinementsymbol'
 import A2_CHAPTER433STELLARFRUITDEWSTONE from '@/components/32_chapter433stellarfruitdewstone'
 import A3_CHAPTER434NINEHIDDENSECRETSINTHETHIEFSECT from '@/components/33_chapter434ninehiddensecretsinthethiefsect'
 import A4_CHAPTER435MONTHLYSACRIFICE from '@/components/34_chapter435monthlysacrifice'
 import A5_CHAPTER436ATHOUSANDYEARSAGOICAMETOSEARCHFORTHEDEVIL from '@/components/35_chapter436athousandyearsagoicametosearchforthedevil'
 import A6_CHAPTER437THEREBEACALAMITYATTHEDOOROFTHECOFFIN from '@/components/36_chapter437therebeacalamityatthedoorofthecoffin'
 import A7_CHAPTER438INVIGORATINGQI from '@/components/37_chapter438invigoratingqi'
 import A8_CHAPTER439BLACKSTONESHADOW from '@/components/38_chapter439blackstoneshadow'
 import A9_CHAPTER440LIFESAVINGSOUNDTRANSMITTING from '@/components/39_chapter440lifesavingsoundtransmitting'
 import A0_CHAPTER441SACRIFICIALRUNE from '@/components/40_chapter441sacrificialrune'
 import A1_CHAPTER442SOULSUPPRESSINGSTONE from '@/components/41_chapter442soulsuppressingstone'
 import A2_CHAPTER443UNDERCURRENTOFEARTHSPIRITNET from '@/components/42_chapter443undercurrentofearthspiritnet'
 import A3_CHAPTER444DESTROYINGTHECOMPASS from '@/components/43_chapter444destroyingthecompass'
 import A4_CHAPTER445BLACKHORSETEMPLE from '@/components/44_chapter445blackhorsetemple'
 import A5_CHAPTER446PORTALOFBLOOD from '@/components/45_chapter446portalofblood'
 import A6_CHAPTER447MAGICTOOLSTING from '@/components/46_chapter447magictoolsting'
 import A7_CHAPTER448THIRTEENMOREDEAD from '@/components/47_chapter448thirteenmoredead'
 import A8_CHAPTER449EVILENERGYENTRYPOINT from '@/components/48_chapter449evilenergyentrypoint'
 import A9_CHAPTER450EVILRIVER from '@/components/49_chapter450evilriver'
 import A0_CHAPTER451XANTHANARRAY from '@/components/50_chapter451xanthanarray'
 import A1_CHAPTER452ZOOMOUT from '@/components/51_chapter452zoomout'
 import A2_CHAPTER453YOUCANGONOW from '@/components/52_chapter453youcangonow'
 import A3_CHAPTER454MOUNTAINLIFTINGMETHOD from '@/components/53_chapter454mountainliftingmethod'
 import A4_CHAPTER455BLACKWINDNEGATIVECURRENT from '@/components/54_chapter455blackwindnegativecurrent'
 import A5_CHAPTER456THEHEARTOFANCIENTLAIISDIFFICULTTOOPEN from '@/components/55_chapter456theheartofancientlaiisdifficulttoopen'
 import A6_CHAPTER457THEREWASACTUALLYSUCHANOPERATION from '@/components/56_chapter457therewasactuallysuchanoperation'
 import A7_CHAPTER458THEGHOSTSAREGONE from '@/components/57_chapter458theghostsaregone'
 import A8_CHAPTER459CHIEFSTEWARDLIU from '@/components/58_chapter459chiefstewardliu'
 import A9_CHAPTER460TWOSIDEDFLAG from '@/components/59_chapter460twosidedflag'
 import A0_CHAPTER461ASTRONGSENSEOFLONELINESS from '@/components/60_chapter461astrongsenseofloneliness'
 import A1_CHAPTER462GIVEAWOMANTREEADROPOFBLOOD from '@/components/61_chapter462giveawomantreeadropofblood'
 import A2_CHAPTER463WHATTHEHELLAREYOUTWODOING from '@/components/62_chapter463whatthehellareyoutwodoing'
 import A3_CHAPTER464ITISNOTEASYTOBEAGHOSTKING from '@/components/63_chapter464itisnoteasytobeaghostking'
 import A4_CHAPTER465MAJORYINQIPLEADINGS from '@/components/64_chapter465majoryinqipleadings'
 import A5_CHAPTER466HELLHOLE from '@/components/65_chapter466hellhole'
 import A6_CHAPTER467OPENSPACEBETWEENTHESUNANDTHESUN from '@/components/66_chapter467openspacebetweenthesunandthesun'
 import A7_CHAPTER468ABOWLOFMULTICOLOREDFLOWERCONGEE from '@/components/67_chapter468abowlofmulticoloredflowercongee'
 import A8_CHAPTER469EARTHGODPILL from '@/components/68_chapter469earthgodpill'
 import A9_CHAPTER470SICKNINEREVOLVINGLIFEPILL from '@/components/69_chapter470sickninerevolvinglifepill'
 import A0_CHAPTER471THEEXQUISITEHORSERUNSFAST from '@/components/70_chapter471theexquisitehorserunsfast'
 import A1_CHAPTER472THEGREATUNKNOWABLEWIDTHOFTHEGHOSTREALM from '@/components/71_chapter472thegreatunknowablewidthoftheghostrealm'
 import A2_CHAPTER473GHOSTBEASTSWITHNINECLAWS from '@/components/72_chapter473ghostbeastswithnineclaws'
 import A3_CHAPTER474EIGHTEENDOLLARS from '@/components/73_chapter474eighteendollars'
 import A4_CHAPTER475TAOISM from '@/components/74_chapter475taoism'
 import A5_CHAPTER476NINEREVOLVINGLIFEPILL from '@/components/75_chapter476ninerevolvinglifepill'
 import A6_CHAPTER477SEALEDHOLE from '@/components/76_chapter477sealedhole'
 import A7_CHAPTER478IMGONNAKILLYOUGUYS from '@/components/77_chapter478imgonnakillyouguys'
 import A8_CHAPTER479BLACKGOURD from '@/components/78_chapter479blackgourd'
 import A9_CHAPTER480LEFTPROTECTORMODI from '@/components/79_chapter480leftprotectormodi'
 import A0_CHAPTER481THECALLOFTHESTARSISVERYPOWERFUL from '@/components/80_chapter481thecallofthestarsisverypowerful'
 import A1_CHAPTER482LIUHUASVISIT from '@/components/81_chapter482liuhuasvisit'
 import A2_CHAPTER483THESTORYOFATHOUSANDYEARSAGO from '@/components/82_chapter483thestoryofathousandyearsago'
 import A3_CHAPTER484LIUHUASABNORMALITY from '@/components/83_chapter484liuhuasabnormality'
 import A4_CHAPTER485FISSUREDFOG from '@/components/84_chapter485fissuredfog'
 import A5_CHAPTER486FORBIDDENSKILLOFREFINING from '@/components/85_chapter486forbiddenskillofrefining'
 import A6_CHAPTER487AGREATWAR from '@/components/86_chapter487agreatwar'
 import A7_CHAPTER488PLEADFORMERCYAFTERLOSINGTHENORTH from '@/components/87_chapter488pleadformercyafterlosingthenorth'
 import A8_CHAPTER489NETHERPOOLCULTIVATION from '@/components/88_chapter489netherpoolcultivation'
 import A9_CHAPTER490KILLINGTHEDEVIL from '@/components/89_chapter490killingthedevil'
 import A0_CHAPTER491GRACETENTHOUSAND from '@/components/90_chapter491gracetenthousand'
 import A1_CHAPTER492THELEFTPROTECTOROFTHEDEMONS from '@/components/91_chapter492theleftprotectorofthedemons'
 import A2_CHAPTER493UNLUCKYBIRD from '@/components/92_chapter493unluckybird'
 import A3_CHAPTER494YUNHETAOISTHEAD from '@/components/93_chapter494yunhetaoisthead'
 import A4_CHAPTER495MASTERFANGYINGISHERE from '@/components/94_chapter495masterfangyingishere'
 import A5_CHAPTER496OPENINGOFTHEDEVILSGATE from '@/components/95_chapter496openingofthedevilsgate'
 import A6_CHAPTER497KILLINGTHEDEMONSOLDIERS from '@/components/96_chapter497killingthedemonsoldiers'
 import A7_CHAPTER498BETRAPPEDINAMAGICSTAR from '@/components/97_chapter498betrappedinamagicstar'
 import A8_CHAPTER499LOOSENINGOFFOURSIDESFORMATION from '@/components/98_chapter499looseningoffoursidesformation'
 import A9_CHAPTER500MIGHTYENCIRCLEMENT from '@/components/99_chapter500mightyencirclement'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter401usingfortunetellingasaguide",
 			"name" : "0_chapter401usingfortunetellingasaguide",
 			"component" : A_CHAPTER401USINGFORTUNETELLINGASAGUIDE
 		},
 		{
 			"path" : "/1_chapter402evilavoidingneedstogosouth",
 			"name" : "1_chapter402evilavoidingneedstogosouth",
 			"component" : A_CHAPTER402EVILAVOIDINGNEEDSTOGOSOUTH
 		},
 		{
 			"path" : "/2_chapter403departurehurtsthemost",
 			"name" : "2_chapter403departurehurtsthemost",
 			"component" : A_CHAPTER403DEPARTUREHURTSTHEMOST
 		},
 		{
 			"path" : "/3_chapter404cloudmudtemple",
 			"name" : "3_chapter404cloudmudtemple",
 			"component" : A_CHAPTER404CLOUDMUDTEMPLE
 		},
 		{
 			"path" : "/4_chapter405repairingcorpsecontrolarray",
 			"name" : "4_chapter405repairingcorpsecontrolarray",
 			"component" : A_CHAPTER405REPAIRINGCORPSECONTROLARRAY
 		},
 		{
 			"path" : "/5_chapter406theaftertasteisthefastnoodle",
 			"name" : "5_chapter406theaftertasteisthefastnoodle",
 			"component" : A_CHAPTER406THEAFTERTASTEISTHEFASTNOODLE
 		},
 		{
 			"path" : "/6_chapter407roundnessasademon",
 			"name" : "6_chapter407roundnessasademon",
 			"component" : A_CHAPTER407ROUNDNESSASADEMON
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js